
import { util, language, user, url, elk } from '@tencent/ppd-base-libs';
import { ERouterName } from '@/config';
import { MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';
import { getJumpConfig } from '@/api';


/** 获取从配置中获取对应商户的跳转信息 */
export async function getJumpInfoFromRemoteConfig(merchantId: string): Promise<MultiJumpInfo> {
  if (!merchantId) {
    throw new Error('merchantId required');
  }
  const configRes = await getJumpConfig();
  const target = configRes.configList.find(item => item.merchantId === merchantId);
  if (!target) {
    throw new Error(`con not found config by merchantId:${merchantId}`);
  }
  return {
    appid: target.appId,
    path: target.appUrl,
  };
}

/** 跳转到小程序中转页面 */
export function jumpMpRedirectPage(merchantId: string) {
  const uin = user.getUin();
  const adtag = url.getParamAdtag();
  const params = `merchantId=${merchantId}&uin=${uin}&adtag=${adtag}&lang=${language.getLang()}`;
  elk({
    key: 'jumpMpRedirectPage',
    msg: params,
  });
  //  跳转到小程序中转页
  wx.miniProgram.redirectTo({
    url: `/pages/redirectpage/index?${params}`,
  });
}


/** 处理拉起第三方小程序 */
export async function handleMerchantJump(mrchId: string, router) {
  // 非香港钱包地区时跳转走
  if (util.isInMiniProgram()) {
    jumpMpRedirectPage(mrchId);
  } else {
    // 跳转中转页
    router.replace({
      name: ERouterName.thirdmpredirect,
    });
  }
}
